package fr.arcplex.sooner

import fr.arcplex.sooner.infrastructure.PlatformIdentity

expect fun getLocalStorageItem(key: String): String?
expect fun setLocalStorageItem(key: String, value: String)

class WebIdentity : PlatformIdentity {
    override fun getMacAddress(): String = "web-mac"
    override fun getUserToken(): String? = getLocalStorageItem("user_token")
    override fun saveUserToken(token: String) {
        setLocalStorageItem("user_token", token)
    }
}

expect fun getWebIdentity(): PlatformIdentity

